import script from "./CultureView.vue?vue&type=script&setup=true&lang=js"
export * from "./CultureView.vue?vue&type=script&setup=true&lang=js"

import "./CultureView.vue?vue&type=style&index=0&id=bfb37dd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfb37dd8"]])

export default __exports__